import { EColors, EFont } from "common/styles";
import styled from "styled-components";

export const StyledContactsList = styled.ul`
list-style: none;
display:flex;
flex-direction:column;
gap:28px;
@media screen and (min-width: 450px) {
display:grid;
grid-template-columns:1fr 1fr;
grid-template-rows:1fr 1fr;
column-gap:24px;
row-gap:28px;
}
`
export const StyledContactItem = styled.li`
background:transparent;
`
export const StyledPhone = styled.p`
font-family: ${EFont.Fira_Sans};
 font-weight: 400;
  font-size: 24px;
  line-height: 33.6px;
  font-feature-settings: "case" on;
  color:${EColors.white};
  margin-top:8px;

`